import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class ReleaseFromDelayControllerRequestService {
  private static BASE_URL = '/immo/releaseSubProjectFromDelay';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      ReleaseFromDelayControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public releaseSubProjectFromDelay(subProjectId: number): Promise<void> {
    return this.post(`/${subProjectId}`, null, DeserializeVoid).toPromise();
  }
}
